const ATTACHMENT_UPLOAD = {
  name: 'ATTACHMENT_UPLOAD',
  initialState: {}
};

const ATTACHMENT_DETAILS = {
  name: 'ATTACHMENT_DETAILS',
  initialState: {}
};

const ATTACHMENT_CONFIRM_DELETE = {
  name: 'ATTACHMENT_CONFIRM_DELETE'
};

const CLARIFICATION_CONFIRM_DELETE = {
  name: 'CLARIFICATION_CONFIRM_DELETE'
};

const CASETAFEL_CONFIRM_DELETE = {
  name: 'CASETAFEL_CONFIRM_DELETE'
};

const CLARIFICATION_APPROVE = {
  name: 'CLARIFICATION_APPROVE'
};

const PROCEDURE_GOAL_CONFIRM_DELETE = {
  name: 'PROCEDURE_GOAL_CONFIRM_DELETE'
};

const GOAL_INDICATOR_CONFIRM_DELETE = {
  name: 'GOAL_INDICATOR_CONFIRM_DELETE'
};

const MEASURE_MOMENT_CREATE = {
  name: 'MEASURE_MOMENT_CREATE',
  initialState: { attachments: [] }
};

const MEASURE_MOMENT_DETAILS = {
  name: 'MEASURE_MOMENT_DETAILS',
  initialState: { attachments: [] }
};

const MEASURE_MOMENT_CONFIRM_DELETE = {
  name: 'MEASURE_MOMENT_CONFIRM_DELETE'
};

const CASETAFEL_APPROVE = {
  name: 'CASETAFEL_APPROVE'
};

const CASETAFEL_REJECT = {
  name: 'CASETAFEL_REJECT'
};

const STATUS_CHANGE = {
  name: 'STATUS_CHANGE'
};

const ADMIN_OFFERING_CONFIRM_DELETE = {
  name: 'ADMIN_OFFERING_CONFIRM_DELETE'
};

const IMAGE_PREVIEW_MODAL = {
  name: 'IMAGE_PREVIEW_MODAL'
};

const ADD_THEME_MODAL = {
  name: 'ADD_THEME_MODAL'
};

const UPDATE_THEME_MODAL = {
  name: 'UPDATE_THEME_MODAL'
};

const DELETE_THEME_MODAL = {
  name: 'DELETE_THEME_MODAL'
};

const ADD_CONTACT_MODAL = {
  name: 'ADD_CONTACT_MODAL'
};

const UPDATE_CONTACT_MODAL = {
  name: 'UPDATE_CONTACT_MODAL'
};

const DELETE_CONTACT_MODAL = {
  name: 'DELETE_CONTACT_MODAL'
};

const ADD_SCHOOL_MODAL = {
  name: 'ADD_SCHOOL_MODAL'
};

const ADD_BRANCH_MODAL = {
  name: 'ADD_BRANCH_MODAL'
};

const DELETE_SCHOOL_MODAL = {
  name: 'DELETE_SCHOOL_MODAL'
};

const DELETE_BRANCH_MODAL = {
  name: 'DELETE_BRANCH_MODAL'
};

const STAKEHOLDER_ADD_MODAL = {
  name: 'STAKEHOLDER_ADD_MODAL'
};

const STAKEHOLDER_DETAIL_MODAL = {
  name: 'STAKEHOLDER_DETAIL_MODAL'
};

const STAKEHOLDER_DELETE_WARNING_MODAL = {
  name: 'STAKEHOLDER_DELETE_WARNING_MODAL'
};

const CONTACTMOMENTS_ADD_MODAL = {
  name: 'CONTACTMOMENTS_ADD_MODAL'
};

const CONTACTMOMENTS_DETAIL_MODAL = {
  name: 'CONTACTMOMENTS_DETAIL_MODAL'
};

const CONTACTMOMENTS_DELETE_WARNING_MODAL = {
  name: 'CONTACTMOMENTS_DELETE_WARNING_MODAL'
};
const ASSIGN_TO_DOSSIER_MODAL = {
  name: 'ASSIGN_TO_DOSSIER_MODAL'
};

const ASSIGN_TO_DOSSIER_CONTACTS_SEARCH_MODAL = {
  name: 'ASSIGN_TO_DOSSIER_CONTACTS_SEARCH_MODAL'
};

const ADD_PARTNER_MODAL = {
  name: 'ADD_PARTNER_MODAL'
};

const UPDATE_PARTNER_MODAL = {
  name: 'UPDATE_PARTNER_MODAL'
};

const PARTNER_DELETE_WARNING_MODAL = {
  name: 'PARTNER_DELETE_WARNING_MODAL'
};

const ADD_CONTACT_ORGANIZATION_MODAL = {
  name: 'ADD_CONTACT_ORGANIZATION_MODAL'
};

const UPDATE_CONTACT_ORGANIZATION_MODAL = {
  name: 'UPDATE_CONTACT_ORGANIZATION_MODAL'
};

const ADD_RELATED_DOSSIER_MODAL = {
  name: 'ADD_RELATED_DOSSIER_MODAL'
};

const UNLINK_RELATED_CONFIRM_MODAL = {
  name: 'UNLINK_RELATED_CONFIRM_MODAL'
};

const ADD_TEMPLATE_MODAL = {
  name: 'ADD_TEMPLATE_MODAL'
};

const UPDATE_TEMPLATE_MODAL = {
  name: 'UPDATE_TEMPLATE_MODAL'
};

const DELETE_TEMPLATE_MODAL = {
  name: 'DELETE_TEMPLATE_MODAL'
};
const ADD_SCHOOL_TO_REQUEST_MODAL = {
  name: 'ADD_SCHOOL_TO_REQUEST_MODAL'
};
const DELETE_SCHOOL_FROM_REQUEST_MODAL = {
  name: 'DELETE_SCHOOL_FROM_REQUEST_MODAL'
};
const DETAIL_SCHOOL_FROM_REQUEST_MODAL = {
  name: 'DETAIL_SCHOOL_FROM_REQUEST_MODAL'
};
const CONTACT_EMAIL_EXISTS_WARNING_MODAL = {
  name: 'CONTACT_EMAIL_EXISTS_WARNING_MODAL'
};
const CONTACT_UPDATE_NO_PERMISSION_MODAL = {
  name: 'CONTACT_UPDATE_NO_PERMISSION_MODAL'
};
const CONTACT_ROLE_EDIT_ERROR_MODAL = {
  name: 'CONTACT_ROLE_EDIT_ERROR_MODAL'
};
const CONTACT_WITH_NO_PERMISSION_WARNING_MODAL = {
  name: 'CONTACT_WITH_NO_PERMISSION_WARNING_MODAL'
};

export const MODALS = {
  ATTACHMENT_UPLOAD,
  ATTACHMENT_DETAILS,
  ATTACHMENT_CONFIRM_DELETE,
  CLARIFICATION_CONFIRM_DELETE,
  CLARIFICATION_APPROVE,
  CASETAFEL_CONFIRM_DELETE,
  PROCEDURE_GOAL_CONFIRM_DELETE,
  GOAL_INDICATOR_CONFIRM_DELETE,
  MEASURE_MOMENT_CREATE,
  MEASURE_MOMENT_DETAILS,
  MEASURE_MOMENT_CONFIRM_DELETE,
  CASETAFEL_APPROVE,
  CASETAFEL_REJECT,
  STATUS_CHANGE,
  ADMIN_OFFERING_CONFIRM_DELETE,
  IMAGE_PREVIEW_MODAL,
  ADD_THEME_MODAL,
  UPDATE_THEME_MODAL,
  DELETE_THEME_MODAL,
  ADD_CONTACT_MODAL,
  UPDATE_CONTACT_MODAL,
  DELETE_CONTACT_MODAL,
  ADD_SCHOOL_MODAL,
  ADD_BRANCH_MODAL,
  DELETE_SCHOOL_MODAL,
  DELETE_BRANCH_MODAL,
  STAKEHOLDER_ADD_MODAL,
  STAKEHOLDER_DETAIL_MODAL,
  STAKEHOLDER_DELETE_WARNING_MODAL,
  CONTACTMOMENTS_ADD_MODAL,
  CONTACTMOMENTS_DETAIL_MODAL,
  CONTACTMOMENTS_DELETE_WARNING_MODAL,
  ASSIGN_TO_DOSSIER_MODAL,
  ASSIGN_TO_DOSSIER_CONTACTS_SEARCH_MODAL,
  ADD_PARTNER_MODAL,
  UPDATE_PARTNER_MODAL,
  PARTNER_DELETE_WARNING_MODAL,
  UPDATE_CONTACT_ORGANIZATION_MODAL,
  ADD_CONTACT_ORGANIZATION_MODAL,
  ADD_RELATED_DOSSIER_MODAL,
  UNLINK_RELATED_CONFIRM_MODAL,
  ADD_TEMPLATE_MODAL,
  UPDATE_TEMPLATE_MODAL,
  DELETE_TEMPLATE_MODAL,
  ADD_SCHOOL_TO_REQUEST_MODAL,
  DETAIL_SCHOOL_FROM_REQUEST_MODAL,
  DELETE_SCHOOL_FROM_REQUEST_MODAL,
  CONTACT_EMAIL_EXISTS_WARNING_MODAL,
  CONTACT_UPDATE_NO_PERMISSION_MODAL,
  CONTACT_ROLE_EDIT_ERROR_MODAL,
  CONTACT_WITH_NO_PERMISSION_WARNING_MODAL
};
